/* Videos aus dem Kanal-Feed von Irontech Doll Official – Leonard.
   Kanal-ID UCkSpT5XeD8vrIDXiQkVrCuA, Stand 2026-09-04.
   Vorschaubilder liegen lokal, damit die Seite ohne Google-Verbindung laedt. */
window.DIL_VIDEOS = [
 {
  "id": "697_CHlE6oM",
  "titel": "Looking for the Best Asian Sex Doll? | RL150 R11 Alara Real Lady Doll Review by Leo",
  "datum": "2026-09-04",
  "text": "#IrontechDoll #SexDollReview #RealLadyDoll",
  "bild": DIL.assets + "dil-mediathek-697_CHlE6oM.jpg"
 },
 {
  "id": "zhwJRZXPdNc",
  "titel": "Looking for the Most Life Like Sex Doll? | IR 168 S17 Luna Irontech Doll Review by Leo",
  "datum": "2026-09-01",
  "text": "#IrontechDoll #SexDollReview #RealLadyDoll",
  "bild": DIL.assets + "dil-mediathek-zhwJRZXPdNc.jpg"
 },
 {
  "id": "yVRR5lLrAis",
  "titel": "Looking for the Best BBW Silicone Sex Doll? | 164LN S19 Pearl Irontech Review by Leo",
  "datum": "2026-08-28",
  "text": "#IrontechDoll #SexDollReview #SexDolls",
  "bild": DIL.assets + "dil-mediathek-yVRR5lLrAis.jpg"
 },
 {
  "id": "2QtIBbJ3Ibk",
  "titel": "Erovenus - No.1 Luxury Sex Doll Torso Brand | Erovenus Max Series Lana Review by Leo",
  "datum": "2026-08-26",
  "text": "#IrontechDoll #SexDollReview #Erovenus",
  "bild": DIL.assets + "dil-mediathek-2QtIBbJ3Ibk.jpg"
 },
 {
  "id": "0jgTDfergDQ",
  "titel": "Looking for the Most Realistic Sex Dolls? | 159T T4 Evie Irontech Doll Review by Leo",
  "datum": "2026-08-21",
  "text": "#IrontechDoll #SexDollReview #SexDoll ",
  "bild": DIL.assets + "dil-mediathek-0jgTDfergDQ.jpg"
 },
 {
  "id": "DLmXh_BJUjU",
  "titel": "Looking for Lightweight Silicone Sex Dolls? | Irontech Doll ULW Technology Release",
  "datum": "2026-08-13",
  "text": "#IrontechDoll #ULWTechnology #SiliconeDollTechnology",
  "bild": DIL.assets + "dil-mediathek-DLmXh_BJUjU.jpg"
 },
 {
  "id": "sFPncHyhfbM",
  "titel": "Is This the Future of Lightweight Sex Dolls? | Real Lady Doll ULW Technology Release",
  "datum": "2026-08-07",
  "text": "#IrontechDoll #ULWTechnology #RealLadyDoll",
  "bild": DIL.assets + "dil-mediathek-sFPncHyhfbM.jpg"
 },
 {
  "id": "YB7UdZDVYLQ",
  "titel": "Most Realistic Life Size Sex Doll Yet? | RL170 R16 Helena Real Lady Sex Doll Review by Leo",
  "datum": "2026-07-31",
  "text": "#IrontechDoll #SexDollReview #RealLadyDoll",
  "bild": DIL.assets + "dil-mediathek-YB7UdZDVYLQ.jpg"
 },
 {
  "id": "u9iApvaLQN4",
  "titel": "The Best Petite Silicone Sex Doll? | RL150 R8 Lena Real Lady Doll Review by Leo",
  "datum": "2026-07-23",
  "text": "#IrontechDoll #SexDollReview #RealLadyDoll",
  "bild": DIL.assets + "dil-mediathek-u9iApvaLQN4.jpg"
 },
 {
  "id": "u2AJnnm-pjE",
  "titel": "The Best Asian Silicone Sex Doll? | 158T A4 Misaki Irontech Doll Review by Leo",
  "datum": "2026-07-17",
  "text": "#IrontechDoll #SexDollReview #RealLadyDoll",
  "bild": DIL.assets + "dil-mediathek-u2AJnnm-pjE.jpg"
 },
 {
  "id": "_siOmy-_KSs",
  "titel": "Best Silicone Sex Dolls 2026 | Erovenus vs Irontech vs Real Lady Review",
  "datum": "2026-07-09",
  "text": "Hi everyone, welcome back to Irontech Doll Leo’s channel — your go-to place for Irontech Doll, Real Lady Doll news, and in-depth sex doll reviews.",
  "bild": DIL.assets + "dil-mediathek-_siOmy-_KSs.jpg"
 },
 {
  "id": "IYZzy-N50iI",
  "titel": "Is This the Most Realistic Silicone Sex Doll? | Real Lady RL159 R12 Hailey Honey Bronze Review",
  "datum": "2026-07-04",
  "text": "#RealisticSexDoll #SiliconeSexDoll #SexDollReview",
  "bild": DIL.assets + "dil-mediathek-IYZzy-N50iI.jpg"
 },
 {
  "id": "E6RNb-y4W2Y",
  "titel": "Erovenus Roxy Review | The Most Realistic BBW Silicone Sex Doll Torso?",
  "datum": "2026-06-26",
  "text": "Today, we’re taking a closer look at Roxy — the ultimate tan BBW silicone sex doll from Erovenus.",
  "bild": DIL.assets + "dil-mediathek-E6RNb-y4W2Y.jpg"
 },
 {
  "id": "QclbmWJ-EFQ",
  "titel": "Looking for the Sexiest Latina Sex Doll? | RL168 R15 Sienna Real Lady Sex Doll Review",
  "datum": "2026-06-20",
  "text": "Hi everyone, welcome back to Irontech Doll Leo’s channel — your go-to place for Irontech Doll, Real Lady Doll news, and in-depth sex doll reviews.",
  "bild": DIL.assets + "dil-mediathek-QclbmWJ-EFQ.jpg"
 },
 {
  "id": "PgzMcGIgrbM",
  "titel": "EDEN Japan Adult Expo 2026 | Full Booth Tour of Irontech & Real Lady Sex Dolls",
  "datum": "2026-06-14",
  "text": "Step inside EDEN Japan Adult Expo 2026 with Leo and explore the latest innovations from Irontech Group, featuring both Irontech and Real Lady.",
  "bild": DIL.assets + "dil-mediathek-PgzMcGIgrbM.jpg"
 }
];
